import { useFormik } from 'formik';
import { useState } from 'react';
import { SudoButton } from "src/sudokit/components/SudoButton";
import styled from "styled-components/macro";
import * as yup from "yup";
import Auth from "../../Auth";
import { ErrorMessage, FieldErrorMessage, FlexColumn, FlexRow, mixins } from "./styles";

const UserNoteFormContent = styled.div`
  ${mixins.card}
  ${mixins.flexColumn}

  gap: 8px;
  justify-content: space-around;

  h4 {
    color: #777;
  }
`;

const UserNoteFormControls = styled(FlexRow)`
  gap: 16px;
  display: flex;
  align-items: flex-start;
  justify-content: stretch;

  .field {
    flex: 1;

  }

  #note-form-submit,
  #note-form-cancel {
    margin: 2px 0;
  }
`;

const UserNoteForm = ({ onAdd, onCancel, user }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const formik = useFormik({
    initialValues: {
      content: '',
    },
    validationSchema: yup.object({
      content: yup.string().required('Note content is required').min(1),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const { userNote } = await Auth.fetchWithIdToken(`/api/admin/userNotes/${user.uid}/add`, {
          method: 'POST',
          ...values,
        });

        formik.resetForm();
        setError(null);
        setLoading(false);
        onAdd(userNote);
      } catch (error) {
        console.error(error);
        setError("Unable to add the note");
        setLoading(false);
      }

    }
  });

  const handleCancel = () => {
    formik.resetForm();
    onCancel();
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <UserNoteFormContent>
        {/* TODO: Change error to red */}
        <h4>Add a new note</h4>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <UserNoteFormControls>
          <div className='field'>
            <textarea value={formik.values.content} className="border rounded-lg p-2 resize-y w-[calc(100%-16px)]" rows={4} name='content' onChange={formik.handleChange} onBlur={formik.handleBlur} />
            {formik.touched.content && formik.errors.content && (
              <FieldErrorMessage>{formik.errors.content}</FieldErrorMessage>
            )}
          </div>
          <FlexColumn>
            <SudoButton
              id='note-form-submit'
              type="submit"
              variant="primary"
              size="small"
              disabled={loading}
              state={loading ? "loading" : "default"}
            >
              Add
            </SudoButton>
            {!loading && (
              <SudoButton
                id='note-form-cancel'
                type="button"
                variant="secondary"
                size="small"
                onClick={handleCancel}
              >
                Cancel
              </SudoButton>
            )}
          </FlexColumn>
        </UserNoteFormControls>
      </UserNoteFormContent>
    </form>
  );
};

export default UserNoteForm;
